/* ============================================
   NIMBA FOODS — Reveal Offer Popup
   Desktop: 10s timer + exit-intent backup
   Mobile:  10s timer + 40% scroll (first wins)
   ============================================ */

(function () {
  'use strict';

  var popupShown = false;
  var submitted = sessionStorage.getItem('nb_email_submitted') === '1';
  var popupDismissed = sessionStorage.getItem('nb_popup_dismissed') === '1';
  var isMobile = window.innerWidth < 768;
  var assetNode = document.getElementById('nb-asset-base');
  var logoUrl = assetNode?.dataset.logo || '';
  var popupProductUrl = assetNode?.dataset.popupProduct || '';

  function normalizeOfferCopy() {
    document.querySelectorAll('a, h2, p').forEach(function (el) {
      if (el.textContent.indexOf('First Jar') !== -1) {
        el.textContent = el.textContent.replace(/First Jar/g, 'First Order');
      }
      if (el.textContent.indexOf('first jar') !== -1) {
        el.innerHTML = el.innerHTML.replace(/first jar/g, 'first order');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeOfferCopy, { once: true });
  } else {
    normalizeOfferCopy();
  }

  var qrIntent = window.location.hash === '#process' || /[?&]utm_source=qr\b/.test(window.location.search);
  var forcePopup = /[?&]nb_popup=1\b/.test(window.location.search) || window.location.hash === '#offer';

  if (!forcePopup && (submitted || popupDismissed || qrIntent)) return;

  function buildPopup() {
    if (popupShown) return;
    popupShown = true;

    var overlay = document.createElement('div');
    overlay.className = 'nb-popup-overlay';
    overlay.innerHTML =
      '<div class="nb-popup-card nb-popup-card--offer">' +
        '<button class="nb-popup-close" aria-label="Close">&times;</button>' +
        '<div class="nb-popup-media" style="background-image:url(' + popupProductUrl + ')"></div>' +
        '<div class="nb-popup-body">' +
          '<img class="nb-popup-logo" src="' + logoUrl + '" alt="Nimba Foods">' +
          '<h2 class="nb-popup-headline">Reveal Your First Offer</h2>' +
          '<p class="nb-popup-sub">Scratch below to unlock 15% off your first Nimba order.</p>' +
          '<div class="nb-scratch" role="button" tabindex="0" aria-label="Scratch to reveal your offer">' +
            '<div class="nb-scratch__prize">' +
              '<span class="nb-scratch__eyebrow">Unlocked</span>' +
              '<strong>15% Off</strong>' +
              '<span>Use code REAL15</span>' +
            '</div>' +
            '<canvas class="nb-scratch__canvas" width="360" height="180"></canvas>' +
          '</div>' +
          '<form class="nb-popup-form" hidden>' +
            '<input type="email" class="nb-popup-input" placeholder="Your email address" required />' +
            '<div class="nb-popup-use-case" role="radiogroup" aria-label="What will you use it for?">' +
              '<p class="nb-popup-use-case__label">What will you use it for?</p>' +
              '<button type="button" class="nb-popup-pill" data-use-case="personal_ready_made" aria-pressed="false">Personal use - ready-made whipped</button>' +
              '<button type="button" class="nb-popup-pill" data-use-case="diy_body_butter" aria-pressed="false">DIY Body Butter</button>' +
              '<button type="button" class="nb-popup-pill" data-use-case="soap_lotion_maker" aria-pressed="false">Maker - soap, lotion, or balm</button>' +
            '</div>' +
            '<input type="hidden" class="nb-popup-use-case-value" value="" />' +
            '<p class="nb-popup-error" hidden>Please choose an option.</p>' +
            '<button type="submit" class="nb-popup-btn">Email My Code</button>' +
            '<p class="nb-popup-fine">No spam. Unsubscribe anytime.</p>' +
          '</form>' +
          '<p class="nb-popup-success" hidden>Check your inbox. Use code <strong>REAL15</strong> at checkout.</p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    var closeBtn = overlay.querySelector('.nb-popup-close');
    var card = overlay.querySelector('.nb-popup-card');
    var scratch = overlay.querySelector('.nb-scratch');
    var canvas = overlay.querySelector('.nb-scratch__canvas');
    var form = overlay.querySelector('.nb-popup-form');
    var success = overlay.querySelector('.nb-popup-success');
    var useCaseInput = overlay.querySelector('.nb-popup-use-case-value');
    var useCasePills = overlay.querySelectorAll('.nb-popup-pill');
    var useCaseError = overlay.querySelector('.nb-popup-error');

    closeBtn.addEventListener('click', function () { closePopup(overlay); });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup(overlay);
    });

    initScratch(canvas, scratch, function () {
      form.hidden = false;
      card.classList.add('nb-popup-card--revealed');
      scratch.classList.add('nb-scratch--revealed');
      if (typeof ntrack === 'function') ntrack('popup_offer_revealed', { offer: 'REAL15' });
    });

    scratch.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        revealScratch(canvas, scratch, form, card);
      }
    });

    useCasePills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        useCasePills.forEach(function (item) {
          item.classList.remove('nb-popup-pill--selected');
          item.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('nb-popup-pill--selected');
        pill.setAttribute('aria-pressed', 'true');
        useCaseInput.value = pill.dataset.useCase || '';
        useCaseError.hidden = true;
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = overlay.querySelector('.nb-popup-input').value.trim();
      var useCase = useCaseInput.value;
      if (!email) return;
      if (!useCase) {
        useCaseError.hidden = false;
        return;
      }
      onEmailSubmit(email, useCase);
      form.hidden = true;
      success.hidden = false;
      setTimeout(function () { closePopup(overlay); }, 6000);
    });

    requestAnimationFrame(function () {
      overlay.classList.add('nb-popup--visible');
    });
  }

  function initScratch(canvas, scratch, onReveal) {
    var ctx = canvas.getContext('2d');
    var revealed = false;
    var drawing = false;
    var lastCheck = 0;

    function paintCover() {
      var gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
      gradient.addColorStop(0, '#d8c6aa');
      gradient.addColorStop(1, '#9f896c');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'rgba(255,255,255,0.72)';
      ctx.font = '700 34px Raleway, Arial, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('SCRATCH HERE', canvas.width / 2, canvas.height / 2);
    }

    function pointFromEvent(e) {
      var touch = e.touches && e.touches[0];
      var rect = canvas.getBoundingClientRect();
      return {
        x: ((touch ? touch.clientX : e.clientX) - rect.left) * (canvas.width / rect.width),
        y: ((touch ? touch.clientY : e.clientY) - rect.top) * (canvas.height / rect.height)
      };
    }

    function scratchAt(e) {
      if (revealed) return;
      e.preventDefault();
      var point = pointFromEvent(e);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(point.x, point.y, 22, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalCompositeOperation = 'source-over';

      var now = Date.now();
      if (now - lastCheck > 180) {
        lastCheck = now;
        if (clearedPercent(ctx, canvas) > 0.55) reveal();
      }
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      scratch.classList.add('nb-scratch--revealed');
      onReveal();
    }

    paintCover();
    canvas.addEventListener('mousedown', function (e) { drawing = true; scratchAt(e); });
    canvas.addEventListener('mousemove', function (e) { if (drawing) scratchAt(e); });
    window.addEventListener('mouseup', function () { drawing = false; });
    canvas.addEventListener('touchstart', function (e) { drawing = true; scratchAt(e); }, { passive: false });
    canvas.addEventListener('touchmove', function (e) { if (drawing) scratchAt(e); }, { passive: false });
    window.addEventListener('touchend', function () { drawing = false; });
  }

  function clearedPercent(ctx, canvas) {
    var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    var clear = 0;
    for (var i = 3; i < pixels.length; i += 16) {
      if (pixels[i] === 0) clear++;
    }
    return clear / (pixels.length / 16);
  }

  function revealScratch(canvas, scratch, form, card) {
    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
    scratch.classList.add('nb-scratch--revealed');
    if (card) card.classList.add('nb-popup-card--revealed');
    form.hidden = false;
  }

  function closePopup(overlay) {
    overlay.classList.remove('nb-popup--visible');
    sessionStorage.setItem('nb_popup_dismissed', '1');
    popupDismissed = true;
    setTimeout(function () { overlay.remove(); }, 300);
  }

  function onEmailSubmit(email, useCase) {
    sessionStorage.setItem('nb_email_submitted', '1');
    submitted = true;
    if (typeof ntrack === 'function') {
      ntrack('popup_submit', {
        cta_label: 'Email My Code',
        signup_source: 'popup_reveal_offer',
        use_case: useCase,
        offer_code: 'REAL15'
      });
    }
    if (typeof klaviyoSubscribe === 'function') {
      klaviyoSubscribe(email, 'popup_reveal_offer', {
        use_case: useCase,
        offer_code: 'REAL15',
        popup_variant: 'scratch_reveal_offer'
      });
    }
  }

  if (forcePopup) {
    buildPopup();
    return;
  }

  if (!isMobile) {
    setTimeout(function () {
      if (!popupShown && !submitted && !popupDismissed) buildPopup();
    }, 10000);

    document.addEventListener('mouseout', function handler(e) {
      if (e.clientY < 0 && !popupShown && !submitted && !popupDismissed) {
        buildPopup();
        document.removeEventListener('mouseout', handler);
      }
    });
  }

  if (isMobile) {
    setTimeout(function () {
      if (!popupShown && !submitted && !popupDismissed) buildPopup();
    }, 10000);

    function onScroll() {
      var scrollPct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if (scrollPct >= 0.4 && !popupShown && !submitted && !popupDismissed) {
        buildPopup();
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
